<template>
	<b-form-group label="Compañia">
		<b-input-group >
			<b-form-select
				@input="manageGetLocations()"
				autocomplete="off"
				:options="companyOptions"
				v-model="selectedCompany"
			></b-form-select>
		</b-input-group>
	</b-form-group>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import {
	BFormInput,
	BFormGroup,
	BInputGroupAppend,
	BInputGroup,
	BButton,
	BFormSelect,
} from 'bootstrap-vue'
import { getUserData } from '@/auth/utils'
import swal from 'sweetalert2'
export default {
	components: {
		BFormGroup,
		BFormInput,
		BInputGroupAppend,
		BInputGroup,
		BButton,
		BFormSelect,
	},
	data() {
		return {
		}
	},
	computed: {
		...mapState('tableFilters', ['input', 'companyOptions']),
		selectedCompany: {
			set(value) {
				this.setSelectedCompany(value)
			},
			get() {
				return this.$store.state.tableFilters.selectedCompany
			},
		},
	},
	methods: {
		manageGetLocations() {
			this.$emit('getLocations')
			/* const userData = getUserData()
			this.getLocations({ user_id: userData.id })
				.then(response => {})
				.catch(errors => {
					console.error(errors.response.message)
					swal.fire({
						icon: 'error',
						title: '¡Leads no encontrados!',
						text: 'Error de conexión',
						timer: 35000,
					})
				}) */
		},
		...mapActions('locations', ['getLocations']),
		...mapMutations('tableFilters', ['setInput', 'setSelectedCompany']),
		cleanSearchBar() {
			this.setInput(null)
		},
	},
}
</script>
